import { render, staticRenderFns } from "./Experts.vue?vue&type=template&id=7d231240&scoped=true&"
import script from "./Experts.vue?vue&type=script&lang=js&"
export * from "./Experts.vue?vue&type=script&lang=js&"
import style0 from "./Experts.vue?vue&type=style&index=0&id=7d231240&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d231240",
  null
  
)

export default component.exports